module.exports = __webpack_public_path__ + "static/media/02.96b9360d.mp3";